/*
 * Navigational structure
 * on the documentation site
 */
export const sideNavigation = {
  'Web UI': [
    ['Introduction', '/docs'],
    ['Setup', '/docs/setup'],
    ['Releases & versioning', '/docs/releases'],
    ['Blog', '/blog'],
  ],

  'Core Concepts': [
    ['Theming & Design', '/docs/theming'],
    ['Design Tokens', '/docs/design-tokens'],
    ['Media Queries', '/docs/media-queries'],
    ['Animation', '/docs/animation'],
    ['CSS in JS', '/docs/css-in-js'],
    ['Configuration', '/docs/configuration'],
  ],

  Guides: [
    ['Forms', '/docs/forms'],
    ['Right to Left UI', '/docs/right-to-left'],
  ],

  // Tools: [
  // ['Storybook', 'https://vcc-ui-storybook.vercel.app'],
  // ['Playroom', 'https://vcc-ui-playroom.vercel.app'],
  // ],

  Components: {
    Layout: [
      ['Block', '/docs/components/block'],
      ['Flex', '/docs/components/flex'],
      ['Grid', '/docs/components/grid'],
      ['Inline', '/docs/components/inline'],
      ['Spacer', '/docs/components/spacer'],
      ['View', '/docs/components/view'],
    ],

    Typography: [
      ['Text', '/docs/components/text'],
      ['Type Scale', '/docs/TypeScale'],
    ],

    Actions: [
      ['Button', '/docs/components/button'],
      ['Click', '/docs/components/click'],
      ['Link', '/docs/components/link'],
    ],

    Forms: [
      ['Checkbox', '/docs/components/checkbox'],
      ['Message', '/docs/components/message'],
      ['Radio', '/docs/components/radio'],
      ['SelectInput', '/docs/components/select-input'],
      ['Slider', '/docs/components/slider'],
      ['TextArea', '/docs/components/text-area'],
      ['TextInput', '/docs/components/text-input'],
      ['Toggle', '/docs/components/toggle'],
    ],

    Content: [
      ['Accordion', '/docs/packages/react-accordion'],
      ['Card', '/docs/components/card'],
      ['Faqs', '/docs/packages/react-faqs'],
      ['Overlay', '/docs/packages/react-overlay'],
    ],

    'Imagery & Icons': [
      ['FavIcons', '/docs/packages/favicons'],
      ['Icon', '/docs/components/icon'],
      ['IconButton', '/docs/components/icon-button'],
      ['Logo', '/docs/components/logo'],
    ],

    'Indicators & messaging': [
      ['InfoBanner', '/docs/packages/react-info-banner'],
      ['LoadingBar', '/docs/components/loading-bar'],
      ['Spinner', '/docs/components/spinner'],
    ],

    Navigation: [
      ['Breadcrumbs', '/docs/packages/react-breadcrumbs'],
      ['Nav', '/docs/components/nav'],
      ['TabNav', '/docs/components/tab-nav'],
    ],
  },
  'Utils & hooks': [
    ['Descendants', '/docs/packages/react-descendants'],
    ['Layout', '/docs/packages/react-layout-utils'],
    ['Scroll', '/docs/packages/react-scroll-utils'],
    ['React utils', '/docs/packages/react-utils'],
    ['Tracking', '/docs/packages/tracking'],
    ['Translations', '/docs/packages/react-shared-translations'],
  ],
};

export const topbar = [
  { text: 'Docs', href: '/docs' },
  {
    text: 'Storybook',
    href: 'https://vcc-ui-storybook.vercel.app',
  },
  {
    text: 'Playroom',
    href: 'https://vcc-ui-playroom.vercel.app',
  },
];
